const ManagerIcon = ({ className, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.62399 10.2077L6.66732 10.2077C6.91431 10.2077 7.13814 10.3531 7.23845 10.5788L9.09008 14.745L9.35701 12.6096L8.6083 11.1122C8.51143 10.9184 8.52178 10.6884 8.63566 10.5041C8.74954 10.3198 8.95071 10.2077 9.16732 10.2077H10.834C11.0506 10.2077 11.2518 10.3198 11.3656 10.5041C11.4795 10.6884 11.4899 10.9184 11.393 11.1122L10.6443 12.6096L10.9112 14.745L12.7629 10.5788C12.8632 10.3531 13.087 10.2077 13.334 10.2077L13.3773 10.2077C14.126 10.2077 14.7504 10.2076 15.2461 10.2743C15.7692 10.3446 16.2416 10.4993 16.6211 10.8789C17.0007 11.2585 17.1554 11.7308 17.2257 12.254C17.2924 12.7496 17.2923 13.374 17.2923 14.1227V15.6248C17.2923 17.1961 17.2923 17.9818 16.8042 18.4699C16.316 18.9581 15.5303 18.9581 13.959 18.9581H6.04232C4.47097 18.9581 3.6853 18.9581 3.19714 18.4699C2.70899 17.9818 2.70899 17.1961 2.70899 15.6248V14.1227C2.70896 13.3739 2.70894 12.7496 2.77558 12.254C2.84592 11.7308 3.00064 11.2585 3.3802 10.8789C3.75976 10.4993 4.23209 10.3446 4.75526 10.2743C5.2509 10.2076 5.87527 10.2077 6.62399 10.2077Z"
        fill={fill || "#D1D5DB"}
      />
      <path
        d="M10.0007 1.04102C8.04464 1.04102 6.45899 2.62667 6.45899 4.58268V5.41602C6.45899 7.37202 8.04464 8.95768 10.0007 8.95768C11.9567 8.95768 13.5423 7.37202 13.5423 5.41602V4.58268C13.5423 2.62667 11.9567 1.04102 10.0007 1.04102Z"
        fill={fill || "#D1D5DB"}
      />
    </svg>
  );
};

export default ManagerIcon;
